/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Register_Name_RequiredInputs */

const en_auth_register_name_required = /** @type {(inputs: Auth_Register_Name_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please enter your name`)
};

const es_auth_register_name_required = /** @type {(inputs: Auth_Register_Name_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduce tu nombre`)
};

/**
* | output |
* | --- |
* | "Please enter your name" |
*
* @param {Auth_Register_Name_RequiredInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const auth_register_name_required = /** @type {((inputs?: Auth_Register_Name_RequiredInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Register_Name_RequiredInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_register_name_required(inputs)
	return es_auth_register_name_required(inputs)
});